import React, { useState, useEffect } from 'react'
import { useParams,Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AdminHomeHelper from '../../../Components/AdminHomeHelper'

const AdminFacultyView = () => {
    const { facultyId } = useParams();
    const faculties = useSelector((store) => {
      return store.admin.allFaculty.find((faculties) => faculties._id === facultyId);
    });

    if (!facultyId) {
      return <div>Faculty not found</div>;
    }

    return (
        <div>
            <div className="container-fluid p-0">
            <div className="d-flex">
                <div className="print-helper">
                    <AdminHomeHelper />
                </div>
                <div className="mx-1 w-100 ">
                    <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                        <h5><Link to='/admin/allFaculties' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>
                        <h3> <img src="/logo192.png" width={'50px'} alt="" /> Faculty Information</h3>
                        <button  onClick={()=> window.print()} type="button" className="print-helper btn-success btn text-light"> <img src="/image/print.svg" lt="" /> <span className=''>Download</span></button>
                    </div>
                    <div className="col bg-light d-md-flex align-items-center justify-content-between">
                            <div className="stuData w-100">
                                <div className="row">
                                    <div className='sortDetails overflow-hidden col-md-4'>
                                        <img className="img-fluid" width={'250px'}  src={faculties.avatar} alt="Card image cap" />
                                        <h5 className='bg-dark text-light p-1'>{faculties.name}</h5>
                                        <div className="">
                                            <h6 className='d-flex align-items-center'>
                                                <img src="/image/mail.svg" alt="" className='p-1' />
                                                <span className="text-break">{faculties.email}</span>
                                            </h6>
                                            <h6 className='d-flex align-items-center'>
                                                <img src="/image/phone.svg" alt="" className='p-1' />
                                                <span className="text-break">{faculties.facultyMobileNUmber}</span>
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="table-responsive col-md-8">
                                        <table className="table shTable table-striped table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td>Name</td>
                                                    <td>{faculties.name}</td>
                                                </tr>
                                                <tr>
                                                    <td>Email</td>
                                                    <td><small>{faculties.email}</small></td>
                                                </tr>
                                                <tr>
                                                    <td>Faculty Number</td>
                                                    <td>{faculties.registrationNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td>Date Of Joining</td>
                                                    <td>{faculties.joiningYear}</td>
                                                </tr>
                                                <tr>
                                                    <td>Date Of Birth</td>
                                                    <td>{faculties.dob}</td>
                                                </tr>
                                                <tr>
                                                    <td>Department</td>
                                                    <td>{faculties.department}</td>
                                                </tr>
                                                <tr>
                                                    <td>Branch</td>
                                                    <td>{faculties.branch}</td>
                                                </tr>
                                                <tr>
                                                    <td>Gender</td>
                                                    <td>{faculties.gender ? faculties.gender : "NA"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Contact Number</td>
                                                    <td>{faculties.facultyMobileNUmber ?
                                                        faculties.facultyMobileNUmber : "NA"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Blood group</td>
                                                    <td>{faculties.bloodGroup ? faculties.bloodGroup : "NA"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Religion</td>
                                                    <td>{faculties.religion ? faculties.religion : "NA"} </td>
                                                </tr>
                                                <tr>
                                                    <td>Community</td>
                                                    <td>{faculties.community ? faculties.community : "NA"} </td>
                                                </tr>
                                                <tr>
                                                    <td>Aadhar number</td>
                                                    <td>{faculties.aadharCard ? faculties.aadharCard : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Permanent address</td>
                                                    <td ><small>{faculties.address ? faculties.address : "NA" }</small></td>
                                                </tr>
                                                <tr>
                                                    <td>Fathers name</td>
                                                    <td>{faculties.fathersName ? faculties.fathersName : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Fathers occupation</td>
                                                    <td>{faculties.fatherOccupation ? faculties.fatherOccupation : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Mother name</td>
                                                    <td>{faculties.motherName ? faculties.motherName : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Mother’s occupation</td>
                                                    <td>{faculties.motherOccupation ? faculties.motherOccupation : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Parent Contact Number</td>
                                                    <td>{faculties.ParentNumber ? faculties.ParentNumber : "NA"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Annual family income</td>
                                                    <td>{faculties.annualIncome ? faculties.annualIncome : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Bank account number</td>
                                                    <td>{faculties.bankAccountNumber ? faculties.bankAccountNumber : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>IFSC code</td>
                                                    <td>{faculties.IFSCcode ? faculties.IFSCcode : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Bank name</td>
                                                    <td>{faculties.bankName ? faculties.bankName : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Bank branch</td>
                                                    <td>{faculties.bankBranch ? faculties.bankBranch : "NA" }</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminFacultyView
